<template>

  <!-- HERO: Home -->

  <div class="etx-container Container HeroVideo fullheight" :class="paragraphClassList">

    <BlokkliProxyMode :isEditing="isEditing" fieldName="field_video_title_elements_rev" :elements="slides" />
    <!-- <LoaderSwiper /> -->
    <div class="swiper Swiper SwiperHero" :data-swiper-id="sliderId">

      <div class="swiper-wrapper Swiper__wrapper">

        <div v-for="slide in slides" :key="slide.id" class="swiper-slide Swiper__wrapper__slide">


          <div class="etx-background-media BackgroundMedia" :class="slide?.verticalAlign != 'center' ? slide?.verticalAlign : ''">

            <div class="etx-media Media">

              <video autoplay="" muted="" loop="" playsinline="">
                <source :src="slide?.video?.url.path" type="video/mp4">
              </video>

            </div>

          </div>

        </div>
      </div>

    </div>

    <!-- <LoaderSwiper /> -->
    <div class="swiper Swiper SwiperHeroControls" :data-swiper-id="sliderId">

      <div class="swiper-wrapper Swiper__wrapper">

        <div v-for="slide in slides" :key="slide.id" class="swiper-slide Swiper__wrapper__slide">

          <div class="etx-text Text">
            <p>{{slide.title}}</p>
          </div>

        </div>


      </div>

      <div class="Swiper__controls">
        <div class="Swiper__controls__pagination"></div>
      </div>
    </div>

  </div>



</template>

<script lang="ts" setup>
import type { integer } from '@elastic/elasticsearch/lib/api/types';

const props = defineProps<{
  isEditing?: boolean
  sliderId: integer
  slides?: Array<Object>
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'hero_video_slider',
  options: {
    spacingTop: {
      type: 'radios',
      label: 'Oben',
      default: 'pt-0',
      group: 'Innenabstände oben und unten',
      options: {
        'pt-0': '0',
        'pt-25': '25',
        'pt-50': '50',
        'pt-75': '75',
        'pt-100': '100',
        'pt-200': '200',
      },
    },
    spacingBottom: {
      type: 'radios',
      label: 'Unte',
      default: 'pb-0',
      group: 'Innenabstände oben und unten',
      options: {
        'pb-0': '0',
        'pb-25': '25',
        'pb-50': '50',
        'pb-75': '75',
        'pb-100': '100',
        'pb-200': '200',
      },
    },
    backgroundColor: {
      type: 'radios',
      label: 'Hintergrundfarbe Color',
      default: 'bg-secondary',
      displayAs: 'colors',
      options: {
        'white': { class: 'bg-grey-1', label: 'Weiss' },
        'bg-grey-1': { class: 'bg-grey-1', label: 'Hellgrau' },
        'bg-primary': { class: 'bg-primary', label: 'Grün' },
        'bg-secondary': { class: 'bg-secondary', label: 'Blau' },
      },
    },
  },
})


const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

</script>